import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTreeModule } from '@angular/material/tree';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { A11yModule } from '@angular/cdk/a11y';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowseComponent } from './browse/browse.component';
import { ReviewRoutingModule } from './review-routing.module';
import { FileCompareComponent } from './file-compare/file-compare.component';
import { ReviewSetComponent } from './review-set/review-set.component';
import { ArchiveJobComponent } from './archive-job/archive-job.component';
import { ProductionJobSelectComponent } from './production-job-select/production-job-select.component';
import { MultiDocEditComponent } from './multi-doc-edit/multi-doc-edit.component';
import { DeleteDocsComponent } from './delete-docs/delete-docs.component';
import { SharedModule } from '../../shared.module';
import { ExportOperationsComponent } from './export-operations/export-operations.component';
import { ProcessingComponent } from './processing/processing.component';
import { FileSizeWarningComponent } from './file-size-warning/file-size-warning.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MaterialModule } from '../../core/material/material.module';
import { FoldersComponent } from './folders/folders.component';
import { AddEditFolderDialogComponent } from './folders/add-edit-folder/add-edit-folder-dialog.component';
import { ImportFoldersDialogComponent } from './folders/import-folders-dialog/import-folders-dialog.component';
import { AddDocsToReviewSetDialogComponent } from './add-docs-to-review-set-dialog/add-docs-to-review-set-dialog.component';
import { DocReviewValidationMessageComponent } from './validation/doc-review-validation-message/doc-review-validation-message.component';
import { AiMultiDocPromptComponent } from './ai-multi-doc-prompt/ai-multi-doc-prompt.component';
import { PageEditsViewComponent } from './redaction-annotation/page-edits-view/page-edits-view.component';
import { CreateProductionJobDialogComponent } from '../discovery/dialogs/create-production-job-dialog/create-production-job-dialog.component';
import { AiPilotPromptComponent } from './ai-pilot-prompt/ai-pilot-prompt.component';
import { MarkdownToSafeHtmlPipe } from "../../pipes/markdown-to-safe-html.pipe";
import { MarkdownPipe } from "../../pipes/markdown.pipe";
import { ProgressiveTypingDirective } from "../../directives/progressive-typing.directive";

@NgModule({
	declarations: [
		BrowseComponent,
		FileCompareComponent,
		ReviewSetComponent,
		ArchiveJobComponent,
		ProductionJobSelectComponent,
		MultiDocEditComponent,
		DeleteDocsComponent,
		ExportOperationsComponent,
		ProcessingComponent,
		FileSizeWarningComponent,
		PageEditsViewComponent,
		FoldersComponent,
		AddEditFolderDialogComponent,
		ImportFoldersDialogComponent,
		AddDocsToReviewSetDialogComponent,
		DocReviewValidationMessageComponent,
		AiMultiDocPromptComponent,
		CreateProductionJobDialogComponent,
		AiPilotPromptComponent
	],
	exports: [
		FileCompareComponent
	],
	imports: [
		MaterialModule,
		MatSortModule,
		MatDatepickerModule,
		MatSliderModule,
		MatAutocompleteModule,
		MatSlideToggleModule,
		MatTreeModule,
		ReviewRoutingModule,
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		SharedModule,
		DragDropModule,
		ScrollingModule,
		CdkTableModule,
		CdkTreeModule,
		A11yModule,
		NgxSkeletonLoaderModule,
		MarkdownToSafeHtmlPipe,
		MarkdownPipe,
		ProgressiveTypingDirective
	]
})
export class ReviewModule {
}
